import { Model3dEntryResponse } from '@xeovision/shared';
import { toast } from 'vue-sonner';
export interface ProcessDatabase {
  id: string;
}

export interface LoadDatabase {
  id: string;
  message?: string;
  url: string;
  type: string;
  stage: number;
  percent: number;
  loaded: number;
  total: number;
  current: boolean;
}

export const useProcessesStore = defineStore('model-processes-store', () => {
  const processes = ref<ProcessDatabase[]>([]);
  const models = ref<LoadDatabase[]>([]);
  const message = ref('');

  function isProcessToastDisplayed(processId: string) {
    const processEntry = processes.value.find((process) => process.id === processId);

    return processEntry && processEntry.id;
  }

  async function updateDownloadProgress(url: string, loaded: number, total: number, error?: Error) {
    const percent = Math.round((loaded / total) * 100);

    const entry = models.value.find((model) => model.url === url);

    if (entry) {
      entry.current = true;
      entry.percent = percent;
      entry.loaded = loaded;
      entry.total = total;

      if (error) {
        entry.message = error.message;
      } else {
        if (percent === 100) {
          message.value = 'Loading...';
        } else {
          message.value = `Downloading... ${percent}%`;
        }
      }
    }
  }

  function showProcessToast(model3dEntry: Model3dEntryResponse, type, toastData: any) {
    const processId = model3dEntry.id;

    if (isProcessToastDisplayed(processId)) return;

    if (type === 'error') {
      toast.error(toastData.title, {
        description: toastData.description,
        duration: toastData.duration ?? 5000,
        action: toastData.action ?? null,
      });
    } else if (type === 'success') {
      toast.success(toastData.title, {
        description: toastData.description,
        duration: toastData.duration ?? 5000,
        action: toastData.action ?? null,
      });
    } else {
      toast.message(toastData.title, {
        description: toastData.description,
        duration: toastData.duration ?? 5000,
        action: toastData.action ?? null,
      });
    }

    const processEntry = {
      id: processId,
    };

    processes.value.push(processEntry);
  }

  return {
    models,
    processes,
    message,
    showProcessToast,
    isProcessToastDisplayed,
    updateDownloadProgress,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useProcessesStore, import.meta.hot));
}
